import startsWith from 'lodash/fp/startsWith';

export const isActive = ({
  pathname,
  to,
  exclude,
}: {
  pathname: string;
  to: string;
  exclude?: string;
}) => startsWith(to)(pathname) && (!exclude || !startsWith(exclude)(pathname));
